import { redirect, type RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { settingsLoader } from './settings-loader';

export const settingsRoutes: RouteObject = {
  loader: settingsLoader,
  children: [
    {
      path: '/settings',
      lazy: lazyComponent(() => import('@pages/shared/settings'), 'SettingsPage'),
      children: [
        { index: true, loader: () => redirect('/settings/notifications') },
        {
          path: 'notifications',
          lazy: lazyComponent(
            () => import('@pages/shared/settings'),
            'SettingsNotificationsPage',
          ),
        },
        {
          path: 'system',
          lazy: lazyComponent(
            () => import('@pages/shared/settings'),
            'SettingsSystemPage',
          ),
        },
        {
          path: 'profile',
          lazy: lazyComponent(
            () => import('@pages/shared/settings'),
            'SettingsProfilePage',
          ),
        },
        {
          path: 'company',
          lazy: lazyComponent(
            () => import('@pages/shared/settings'),
            'SettingsCompanyPage',
          ),
        },
      ],
    },
  ],
};
